import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, FieldArray, reduxForm, formValueSelector, initialize, change } from 'redux-form';
import { injectIntl } from 'react-intl';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Link from '../../Link/Link';
import Loader from '../../Common/Loader/Loader';
import ImageUploadComponent from '../../../components/Common/ImageUploadComponent';

import messages from '../../../locale/messages';
import validate from './validate';
import submit from './submit';
import { updateTempImages } from '../../../actions/siteadmin/TempImages/updateTempImages';
import { api, subCategoryUploadDir } from '../../../config';

import s from './AddSubCategoryForm.css';
import bt from '../../../components/commonStyle.css';
export class AddSubCategoryForm extends Component {
	static defaultProps = {
		currency: 'USD',
		loading: false
	};

	success = async (fileName) => {
		const { change, updateTempImages } = this.props;
		await change('image', fileName);
		await updateTempImages('SubCategory', 'image', fileName);
	}

	renderField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, maxLength }) => {
		const { formatMessage } = this.props.intl;
		return (
			<Form.Group>
				<label className={bt.labelText} >{label}</label>
				<Form.Control {...input} placeholder={placeholder} type={type} className={bt.formControlInput} maxLength={maxLength}
				/>
				{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}

	renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className }) => {
		const { formatMessage } = this.props.intl
		return (
			<div>
				<Form.Group className={s.formGroup}>
					<div>
						<label className={bt.labelText} >{label}</label>
					</div>
					<div>
						<Form.Control
							{...input}
							className={className}
							placeholder={label}
							as="textarea"
							rows="3"
						>
							{children}
						</Form.Control>
						{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
					</div>
				</Form.Group>
			</div>
		);
	}

	// What this service includes, shown as a checklist in the app.
	//
	// One input per point rather than a single textarea: a textarea would leave
	// the app splitting on a separator the admin has no reason to respect, and
	// stray blank lines or dashes would show up verbatim in the app.
	renderInclusions = ({ fields, label }) => {
		return (
			<div>
				<label className={bt.labelText}>{label}</label>
				{fields.map((item, index) => (
					<div key={index} className={s.inclusionRow}>
						<Field
							name={item}
							type="text"
							component="input"
							className={cx(bt.formControlInput, s.inclusionInput)}
							maxLength={120}
						/>
						<Button
							type="button"
							className={cx(bt.btnPrimaryBorder, s.inclusionBtn)}
							onClick={() => fields.remove(index)}
						>
							&times;
						</Button>
					</div>
				))}
				<Button
					type="button"
					className={cx(bt.btnPrimaryBorder)}
					onClick={() => fields.push('')}
				>
					+
				</Button>
			</div>
		);
	}

	renderSelectField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, children }) => {
		const { formatMessage } = this.props.intl;
		return (
			<Form.Group>
				<label className={bt.labelText} >{label}</label>
				<Form.Control as="select" {...input} placeholder={placeholder} className={fieldClass}>
					{children}
				</Form.Control>
				{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}

	render() {
		const { handleSubmit, image, loading, submitting, id, categories: { getActiveCategories }, subCategoryImageLoder } = this.props;
		const { formatMessage } = this.props.intl;

		return (
			<div className={cx('cardSection', s.widthInner, bt.space5, s.responsiveNoPadding)}>
				<Row>
					<Col md={12} lg={12} sm={12} xs={12} >
						<Card className={s.card}>
							<Form className={s.fullWidth} onSubmit={handleSubmit(submit)} >
								<Col lg={12} md={12} sm={12} xs={12}>
									<h1 className={cx('textAlignRightRTL', s.headingTwo, 'textWhite')}>{id ? formatMessage(messages.editSubCategory) : formatMessage(messages.addSubCategory)}</h1>
								</Col>

								<div className={cx(s.singalCard, s.singleCardMb)}>
									<Form.Group className={s.formGroup}>
										<div className={cx(s.profileImgSection, 'bgBlackTwo')}>
											<div className={'commonFilepicker'}>
												<ImageUploadComponent
													className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
													subTextClass={cx(s.subText, 'textWhiteTwo')}
													subText={formatMessage(messages.maximumUploadSizeLabel)}
													defaultMessage={formatMessage(messages.chooseFile)}
													postUrl={api.apiEndpoint + '/uploadSubCategory'}
													handleDropzone={this.success}
													loaderName={'subCategoryImageLoder'}
													loader={subCategoryImageLoder}
													imageSrc={image ? api.apiEndpoint + subCategoryUploadDir + 'medium_' + image : null}
													fieldName={'image'}
													formName={'AddSubCategoryForm'}
													label={formatMessage(messages.image)}
													labelClass={cx(s.textAlignLeft, 'textAlignLeft', s.dropzoneLabelTitle)}
												/>
											</div>
										</div>
									</Form.Group>
								</div>

								<Row className={s.paddingRoutesSection}>
									<Col lg={6} md={6} sm={6} xs={12}>
										<Form.Group className={s.formGroup}>
											<div>
												<Field
													name="name"
													type="text"
													placeholder={formatMessage(messages.subCategoryName)}
													component={this.renderField}
													label={formatMessage(messages.subCategoryName)}
													labelClass={bt.labelText}
													fieldClass={bt.formControlInput}
												/>
											</div>
										</Form.Group>
									</Col>
									<Col lg={6} md={6} sm={6} xs={12}>
										<Form.Group className={s.formGroup}>
											<div>
												<Field
													name="description"
													type="text"
													placeholder={formatMessage(messages.description)}
													component={this.renderFormControlTextArea}
													label={formatMessage(messages.description)}
													labelClass={bt.labelText}
													fieldClass={bt.formControlInput}
												/>
											</div>
										</Form.Group>
									</Col>
									<Col lg={12} md={12} sm={12} xs={12}>
										<Form.Group className={s.formGroup}>
											<div>
												{/* Angka yang DINYATAKAN admin, bukan ETA hidup.
												    Kosongkan agar baris ini tidak tampil di app. */}
												<Field
													name="typicalArrival"
													type="text"
													placeholder="25 min"
													component={this.renderField}
													label="Typical arrival (shown under the price)"
													labelClass={bt.labelText}
													fieldClass={bt.formControlInput}
												/>
											</div>
										</Form.Group>
									</Col>
									<Col lg={6} md={6} sm={6} xs={12}>
										<Form.Group className={s.formGroup}>
											<div>
												<Field
													name="categoryId"
													placeholder={formatMessage(messages.category)}
													component={this.renderSelectField}
													label={formatMessage(messages.category)}
													labelClass={bt.labelText}
													fieldClass={cx(bt.formControlSelect, bt.formControlInput)}
												>
													<option value={""}>{formatMessage(messages.category)}</option>
													{
														getActiveCategories && getActiveCategories.results && getActiveCategories.results.map(category => (
															<option key={category.id} value={category.id}>{category.name}</option>
														))
													}
												</Field>
											</div>
										</Form.Group>
									</Col>
									<Col lg={6} md={6} sm={6} xs={12}>
										<Form.Group className={s.formGroup}>
											<div>
												<label className={bt.labelText} >{formatMessage(messages.status)}</label>
												<Field name="status" className={cx(bt.formControlSelect, bt.formControlInput)} component="select">
													<option value={"active"}>{formatMessage(messages.active)}</option>
													<option value={"inactive"}>{formatMessage(messages.inactive)}</option>
												</Field>
											</div>
										</Form.Group>
									</Col>
									<Col lg={12} md={12} sm={12} xs={12}>
										<Form.Group className={s.formGroup}>
											<div>
												<FieldArray
													name="inclusions"
													rerenderOnEveryChange={true}
													component={this.renderInclusions}
													label={formatMessage(messages.inclusions)}
												/>
											</div>
										</Form.Group>
									</Col>
								</Row>


								<Col lg={12} md={12} sm={12} xs={12} className={cx(bt.textAlignRight, bt.spaceTop3, 'loadingBtnRTL', 'textAlignLeftRTL')}>
									<Form.Group className={s.formGroup}>
										<div className={s.displayInlineBlock}>
											<Loader
												type={"button"}
												label={formatMessage(messages.submitButton)}
												show={loading}
												buttonType={'submit'}
												className={cx(bt.btnPrimary)}
												disabled={submitting || loading}
												isSuffix={true}
											/>
										</div>
										<Link to={"/siteadmin/sub-category"} className={cx(s.backBtn, bt.btnSecondary, 'backBtnRTL')} >{formatMessage(messages.goBack)}</Link>
									</Form.Group>
								</Col>

							</Form>
						</Card>
					</Col>
				</Row>
			</div>
		)
	}
}
AddSubCategoryForm = reduxForm({
	form: 'AddSubCategoryForm',
	onSubmit: submit,
	validate
})(AddSubCategoryForm);
const selector = formValueSelector('AddSubCategoryForm');
const mapState = (state) => ({
	currency: state.currency,
	image: selector(state, 'image'),
	id: selector(state, 'id'),
	loading: state.loader.AddSubCategory,
	subCategoryImageLoder: state.loader.subCategoryImageLoder
})
const mapDispatch = {
	initialize,
	change,
	updateTempImages
}
export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(AddSubCategoryForm)));
